/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Ignore_Timecodes_HelpInputs */

const en_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strip timecodes (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) from the transcript`)
};

const fr_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les timecodes (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) de la transcription`)
};

const de_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen Sie die Zeitstempel (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) aus dem Transkript.`)
};

const it_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere i codici temporali (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) dalla trascrizione`)
};

const ru_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалите из транскрипта временные коды (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm).`)
};

const es_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar códigos de tiempo (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) de la transcripción`)
};

const zh_cn2_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从转录稿中去除时间码（hh:mm:ss:ff、hh:mm:ss、hh:mm:ss:mmm）。`)
};

const ja_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトからタイムコード（hh:mm:ss:ff、hh:mm:ss、hh:mm:ss:mmm）を削除します。`)
};

const hi_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट से टाइमकोड (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) हटा दें`)
};

const pt_pt2_plain_text_import_ignore_timecodes_help = /** @type {(inputs: Plain_Text_Import_Ignore_Timecodes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrair os códigos de tempo (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) da transcrição.`)
};

/**
* | output |
* | --- |
* | "Strip timecodes (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) from the transcript" |
*
* @param {Plain_Text_Import_Ignore_Timecodes_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_ignore_timecodes_help = /** @type {((inputs?: Plain_Text_Import_Ignore_Timecodes_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Ignore_Timecodes_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "de") return de_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "it") return it_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "ru") return ru_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "es") return es_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "ja") return ja_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "hi") return hi_plain_text_import_ignore_timecodes_help(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_ignore_timecodes_help(inputs)
	return en_plain_text_import_ignore_timecodes_help(inputs)
});